<script lang="ts">
  import { clickOutside } from '@shared/lib';
  import { Icon } from '@shared/ui/icon';
  import { is } from '@shared/lib/utils';

  export let position: 'left' | 'right' = 'right';
  export let sidebarActivity = false;
  export let handleClose: () => void;
</script>

<aside
  class="fixed {is(
    position === 'left',
    'left-0',
    'right-0',
  )} dark:bg-dark-200/80 top-0 z-40 h-full w-full overflow-auto overflow-y-auto overflow-x-hidden bg-white transition-transform md:w-[414px] dark:backdrop-blur-2xl"
  class:-translate-x-full="{position === 'left' ? !sidebarActivity : false}"
  class:translate-x-full="{position === 'right' ? !sidebarActivity : false}"
  use:clickOutside="{!sidebarActivity}"
  on:clickOutsideAction="{handleClose}"
>
  <div
    class="absolute top-[36px] {is(
      position === 'left',
      'left-6',
      'right-6',
    )} stroke-default-900 z-30 w-min transition-transform duration-150 hover:scale-125 hover:stroke-black dark:stroke-white"
  >
    <button on:click="{handleClose}">
      <Icon name="close" width="{24}" height="{24}" />
    </button>
  </div>

  <slot />
</aside>
